module.exports = __webpack_public_path__ + "images/file_icons_v2/pdf-13ff02107cdac26a8c14003b775bde7a.svg";